import type { ClientReleaseChannel } from "../../types/experiment";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Button } from "../ui/button";
import { X } from "lucide-react";

interface ClientReleaseChannelFilterProps {
  value: ClientReleaseChannel;
  onChange: (value: ClientReleaseChannel) => void;
}

export function ClientReleaseChannelFilter({ value, onChange }: ClientReleaseChannelFilterProps) {
  const addChannel = () =>
    onChange({ ...value, release_channels: [...value.release_channels, ""] });
  const updateChannel = (i: number, v: string) => {
    const next = [...value.release_channels];
    next[i] = v;
    onChange({ ...value, release_channels: next });
  };
  const removeChannel = (i: number) =>
    onChange({ ...value, release_channels: value.release_channels.filter((_, j) => j !== i) });

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <Label className="text-xs">Release Channels</Label>
        <Button type="button" variant="outline" size="sm" onClick={addChannel}>
          Add Channel
        </Button>
      </div>
      {value.release_channels.map((ch, i) => (
        <div key={i} className="flex items-center gap-2">
          <Input
            value={ch}
            onChange={(e) => updateChannel(i, e.target.value)}
            placeholder="stable, canary, etc."
            className="flex-1"
          />
          <Button type="button" variant="ghost" size="icon" onClick={() => removeChannel(i)}>
            <X className="h-4 w-4 text-red" />
          </Button>
        </div>
      ))}
    </div>
  );
}
